var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center loading"},[_c('b-spinner',{staticClass:"spinner",attrs:{"label":"Spinning"}}),_c('span',[_vm._v("Loading")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }